import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back ♡");
      nav("/");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md kawaii-card p-8 md:p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-kawaii-pink via-kawaii-peach to-kawaii-lavender flex items-center justify-center shadow-md animate-float">
            <Sparkles className="w-8 h-8 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="mt-4 font-heading text-3xl font-semibold text-kawaii-text">Welcome back ♡</h1>
          <p className="text-sm text-kawaii-textSoft mt-2 text-center">Sign in to My LymphieLog</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-kawaii-textSoft font-semibold">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-4 py-3 rounded-2xl border border-kawaii-border bg-white/60 focus:outline-none focus:ring-2 focus:ring-kawaii-pink font-body"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-kawaii-textSoft font-semibold">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-4 py-3 rounded-2xl border border-kawaii-border bg-white/60 focus:outline-none focus:ring-2 focus:ring-kawaii-pink font-body"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="kawaii-btn w-full py-3 rounded-full font-heading font-semibold text-white bg-gradient-to-r from-kawaii-pink to-kawaii-peach shadow-md disabled:opacity-60"
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-center text-sm text-kawaii-textSoft mt-6 font-body">
          New here?{" "}
          <Link to="/register" data-testid="link-register" className="text-kawaii-pink font-semibold hover:underline">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
